var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIntelligence503Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.758,
    height: 257.758,
    viewBox: "0 0 257.758 257.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H257.758V257.758H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.578,110.4H13.74A10.771,10.771,0,0,0,3,121.139v64.439a10.771,10.771,0,0,0,10.74,10.74H185.578a10.772,10.772,0,0,0,10.74-10.74V121.139A10.771,10.771,0,0,0,185.578,110.4ZM45.96,174.839a21.48,21.48,0,1,1,21.48-21.48A21.543,21.543,0,0,1,45.96,174.839ZM185.578,3H13.74A10.771,10.771,0,0,0,3,13.74V78.179a10.771,10.771,0,0,0,10.74,10.74H185.578a10.771,10.771,0,0,0,10.74-10.74V13.74A10.771,10.771,0,0,0,185.578,3ZM45.96,67.439a21.48,21.48,0,1,1,21.48-21.48A21.543,21.543,0,0,1,45.96,67.439Z",
    transform: "translate(29.22 29.22)",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIntelligence503Icon);
export default __webpack_public_path__ + "static/media/TimeIntelligence_503_Icon.40a45b42e0424383535ce8fb8336a1a0.svg";
export { ForwardRef as ReactComponent };